import React from 'react';
import { Shield, Gamepad2, Users, Activity, Filter, Trophy } from 'lucide-react';
import { Card } from './ui/Card';
export function FeaturesSection() {
  const features = [{
    name: 'Sparkle Shield',
    desc: 'Iron-clad parental controls that put you in charge of playtime.',
    icon: Shield,
    color: 'bg-candy-pink',
    textColor: 'text-white'
  }, {
    name: 'Joy Vault',
    desc: 'A curated library of 500+ premium games, hand-picked by experts.',
    icon: Gamepad2,
    color: 'bg-candy-purple',
    textColor: 'text-white'
  }, {
    name: 'Pixel Pals',
    desc: 'Safe, moderated social features for kids to play with friends.',
    icon: Users,
    color: 'bg-candy-teal',
    textColor: 'text-white'
  }, {
    name: 'Glow Trail',
    desc: 'Track progress and healthy screen-time habits effortlessly.',
    icon: Activity,
    color: 'bg-candy-yellow',
    textColor: 'text-candy-dark'
  }, {
    name: 'Fizz Filter',
    desc: 'Smart age-appropriate content filtering that grows with your child.',
    icon: Filter,
    color: 'bg-candy-lime',
    textColor: 'text-candy-dark'
  }, {
    name: 'Bloom Boost',
    desc: 'A positive rewards system that celebrates creativity and learning.',
    icon: Trophy,
    color: 'bg-candy-coral',
    textColor: 'text-white'
  }];
  return <section id="features" className="py-24 bg-candy-lavender/20 relative overflow-hidden" data-id="element-10">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-candy-pink/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-11"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-candy-teal/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-12"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <span className="text-candy-purple font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-15">
            Features
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-candy-dark" data-id="element-16">
            Superpowers Built Into Every Game
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-17">
          {features.map((feature, index) => <Card key={index} className={`${feature.color} border-none shadow-lg`} hoverEffect={true} data-id="element-18">
              <div className="p-8 h-full flex flex-col items-start" data-id="element-19">
                <div className="bg-white/20 backdrop-blur-sm p-4 rounded-2xl mb-6" data-id="element-20">
                  <feature.icon className={`w-8 h-8 ${feature.textColor}`} data-id="element-21" />
                </div>
                <h3 className={`text-2xl font-bold mb-3 ${feature.textColor}`} data-id="element-22">
                  {feature.name}
                </h3>
                <p className={`text-lg opacity-90 leading-relaxed ${feature.textColor}`} data-id="element-23">
                  {feature.desc}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}